import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import { CenteredSwiper } from "@components-shared/desktop/centered-swiper";
import { EventStatusLegend } from "@features/offer/shared/event/EventStatusLegend";
import {
	EventContext,
	OfferOptionsContext,
	OfferStoreContext,
} from "@gp/components";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import { THEME_SETTINGS } from "@theme-settings";
import classnames from "classnames";
import { observer } from "mobx-react";
import { SwiperSlide } from "swiper/react";

import {
	BettingTypeHeaderBettingGroupsButton,
	BettingTypeHeaderBettingGroupsButtonInfo,
} from "./BettingTypeHeaderBettingGroupsButton";

export const BettingTypeGroupHeader = observer(
	function BettingTypeGroupHeader() {
		const { t } = useTranslation();

		const store = useContext(OfferStoreContext) as
			| EventViewStore
			| AdditionalOfferViewStore;
		const event = useContext(EventContext);

		const offerOptionsContext = useContext(OfferOptionsContext);

		const bettingGroups: BettingTypeHeaderBettingGroupsButtonInfo[] =
			(function () {
				const favoritesBetting =
					store.favoritesBettingTypeGroups?.[event.id];

				const isFavoritesEmpty =
					favoritesBetting &&
					// @ts-expect-error
					(event.favoritesBettingTypesIds?.length ?? 0) === 0;

				const isBetBuilderAvailable =
					event.betBuilder &&
					store?.betBuilderBettingType?.length > 0;

				const bettingGroups: BettingTypeHeaderBettingGroupsButtonInfo[] =
					[];

				bettingGroups.push({
					abrv: "all",
					name: t("BETTING_GROUPS.ALL"),
				});

				if (WEBPACK_IS_BET_BUILDER_ENABLED && isBetBuilderAvailable) {
					bettingGroups.push({
						abrv: "bet-builder",
						name: "Bet Builder",
					});
				}

				if (
					THEME_SETTINGS.features.isFavoritesEnabled &&
					!isFavoritesEmpty
				) {
					bettingGroups.push({
						abrv: "favorites",
						name: t("LIVE.SIDEMENU.FAVORITES"),
					});
				}

				store.bettingTypeGroups.forEach((btg) =>
					bettingGroups.push(btg)
				);

				return bettingGroups;
			})();

		const isBetBuilderAvailable =
			(store?.betBoosterEventPicks?.betBuilderPicksStore?.BBPicks?.size ??
				0) > 0;

		const isBettingTipsAvailable =
			store.bettingTipsStore.bettingTips?.length > 0;

		const isTabsDisplayed = isBetBuilderAvailable || isBettingTipsAvailable;

		const isActiveSubGroup =
			store.displayBettingGroup === "bet-builder" ||
			store.displayBettingGroup === "all";

		const tabsClassName = classnames(
			"event__tabs event__tabs--borderless",
			{
				"u-mar--top--5 u-pad--reset":
					isActiveSubGroup && isTabsDisplayed,
				"u-padd--reset":
					!isActiveSubGroup || (isActiveSubGroup && !isTabsDisplayed),
			}
		);

		return (
			<>
				<div className={tabsClassName}>
					<CenteredSwiper>
						{bettingGroups.map((btg, index) => (
							<SwiperSlide
								key={btg.abrv}
								style={{ width: "auto" }}
							>
								<BettingTypeHeaderBettingGroupsButton
									index={index}
									isActive={
										store.displayBettingGroup === btg.abrv
									}
									bettingTypeGroup={btg}
								/>
							</SwiperSlide>
						))}
					</CenteredSwiper>
				</div>
			</>
		);
	}
);
